__turbopack_context__.v({
  "contents": "sampleColorReport-module__dFX6bq__contents",
  "continueBar": "sampleColorReport-module__dFX6bq__continueBar",
  "eyebrow": "sampleColorReport-module__dFX6bq__eyebrow",
  "figure": "sampleColorReport-module__dFX6bq__figure",
  "note": "sampleColorReport-module__dFX6bq__note",
  "preview": "sampleColorReport-module__dFX6bq__preview",
  "previewButton": "sampleColorReport-module__dFX6bq__previewButton",
  "reasoning": "sampleColorReport-module__dFX6bq__reasoning",
  "report": "sampleColorReport-module__dFX6bq__report",
  "swatches": "sampleColorReport-module__dFX6bq__swatches",
});
